<template>
  <el-dialog
    :title="`XEM NHANH CÁC ĐẶT PHÒNG TRONG ${booking?.booking_type_nm} ${booking?.booking_id}`"
    :visible.sync="dialogQuickViewBookingVisible"
    width="90%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                {{ 'Thông tin chính' }}
              </div>
              <div class="child-w-80">
                <input v-model="searchParams.keyword" type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-col col-9">
            <div
              class="button-group"
              style="display: flex; justify-content: flex-end; gap: 8px"
            >
              <button class="btn primary small" @click="fnGetBookingDetail">
                {{ 'Tìm kiếm' }}
              </button>
              <FormDialog
                v-model="dialogViewCustomerProfileVisible"
                :profile-id="selectedRows[0]?.traveller_id"
                :is-edit="isEdit"
                :is-view="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="statistic">
      <div class="item">
        <div class="number">{{ totalBookings }}</div>
        <div class="text">{{ 'Tổng số đặt phòng' }}</div>
      </div>
      <div class="item">
        <div class="number">{{ totalGuests }}</div>
        <div class="text">{{ 'Tổng số khách' }}</div>
      </div>
    </div>
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        style="height: calc(5 * 34px + 40px + 10px)"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        @selectionChanged="
          rows => {
            selectedRows = rows
          }
        "
      />
      <!-- style="height: calc(40px + 340px + 10px)" -->
    </div>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: flex-end"
    >
      <div
        class="button-containers"
        style="width: 90%; display: flex; justify-content: flex-end"
      >
        <button
          class="btn primary small outline"
          @click="dialogQuickViewBookingVisible = false"
        >
          {{ 'Đóng' }}
        </button>
        <button
          class="btn primary small"
          :disabled="
            !(
              selectedRows.length > 0 &&
              selectedRows.every(item => item?.room_id)
            )
          "
          @click="onCheckin"
        >
          {{ 'Nhận phòng' }}
        </button>
        <button
          class="btn primary small"
          :disabled="!rows.every(item => item?.room_id)"
          @click="onCheckinAll"
        >
          {{ 'Nhận toàn bộ nhóm' }}
        </button>
        <!-- add transaction dialog -->
        <AddTransactionDialog
          v-model="dialogAddTransactionVisible"
          :data="selectedRows[0]"
        />
        <button
          class="btn primary small"
          :disabled="selectedRows.length !== 1"
          @click="onOpenUpdateBookingRoom"
        >
          <!-- @click="dialogBookingRoomDetailVisible = true" -->
          {{ 'Sửa đặt phòng' }}
        </button>
        <!-- <BookingRoomDetailDialog
          v-model="dialogBookingRoomDetailVisible"
          :data="selectedRows[0]"
        /> -->
        <button
          class="btn primary small"
          :disabled="selectedRows.length !== 1"
          @click="dialogChangeRoomVisible = true"
        >
          {{ 'Chuyển phòng' }}
        </button>
        <!-- change room dialog -->
        <ChangeRoomDialog
          v-model="dialogChangeRoomVisible"
          :data="selectedRows[0]"
          @onReloadAfterChangeRoom="
            $emit('onReloadAfterCheckin')
            fnGetBookingDetail()
          "
        />
        <button
          class="btn primary small"
          :disabled="selectedRows.length !== 1"
          @click="dialogCancelBookingVisible = true"
        >
          {{ 'Hủy đặt phòng' }}
        </button>
        <!-- cancel booking dialog -->
        <CancelBookingDialog
          v-model="dialogCancelBookingVisible"
          :data="selectedRows[0]"
        />
      </div>
    </span>
    <el-dialog
      :visible.sync="isBookingRoomDialogOpened"
      title="Thông tin đặt phòng"
      width="80%"
      append-to-body
      @close="onCloseBookingRoomDialog"
    >
      <BookingRoomForm
        ref="BookingRoomForm"
        :action="bookingRoomFormAction"
        :record-data="bookingRoomFormData"
      ></BookingRoomForm>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button
          v-if="bookingRoomFormAction == 'create'"
          class="btn primary small"
          @click="onCreateBookingRoom"
        >
          Thêm
        </button>
        <button
          v-if="bookingRoomFormAction == 'edit'"
          class="btn primary small"
          @click="onUpdateBookingRoom"
        >
          Cập nhật
        </button>
        <button
          class="btn primary small outline"
          @click="onCloseBookingRoomDialog"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getBookingInfoDetail } from '@/api/reception/reception'
import AddTransactionDialog from './AddTransactionDialog.vue'
import ChangeRoomDialog from './ChangeRoomDialog.vue'
import CancelBookingDialog from './CancelBookingDialog.vue'
import FormDialog from '../../configuration/profile/customer/components/FormDialog.vue'
import BookingRoomForm from '@/components/resources/booking/BookingRoomForm'
import { checkin } from '@/api/reception/reception'
import {
  getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { notifyError, notifySuccess } from '@/utils/toast'

import { formatVND } from '@/utils/commonUtils'

export default {
  components: {
    BookingRoomForm,
    AddTransactionDialog,
    ChangeRoomDialog,
    CancelBookingDialog,
    FormDialog
    // BookingRoomDetailDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    booking: {
      type: Object
    }
  },
  data() {
    return {
      isBookingRoomDialogOpened: false,
      bookingRoomFormAction: 'edit',
      bookingRoomFormData: null,
      dialogQuickViewBookingVisible: this.value,
      searchParams: {
        type: null,
        bookingId: null,
        keyword: null
      },
      defaultSearchParams: {
        type: null,
        bookingId: null,
        keyword: null
      },

      columns: [
        { headerName: 'Số Folio/Mã đoàn', field: 'recode', width: 150 },
        { headerName: 'Tên', field: 'first_name', width: 100 },
        { headerName: 'Họ', field: 'last_name', width: 100 },
        { headerName: 'VIP', field: 'vip', width: 100 },
        { headerName: 'Quốc tịch', field: 'nationality_nm', width: 150 },
        { headerName: 'Phòng', field: 'room_num', width: 100 },
        { headerName: 'Mã hạng phòng', field: 'room_level_cd', width: 120 },
        { headerName: 'Ngày đến', field: 'arrive_date' },
        { headerName: 'Ngày đi', field: 'depart_date' },
        { headerName: 'Đêm', field: 'num_of_night', width: 80 },
        { headerName: 'Người lớn', field: 'adult_num', width: 100 },
        { headerName: 'Trẻ em', field: 'child_num', width: 80 },
        {
          headerName: 'Trạng thái đặt phòng',
          field: 'status',
          valueFormatter(params) {
            const roomType = parseInt(params.value)
            switch (roomType) {
              case 1:
                return 'Đã đặt'
              case 2:
                return 'Đang ở'
              case 3:
                return 'Đã hủy'
              case 4:
                return 'Đã trả phòng'
              default:
                return 'Không xác định'
            }
          },
          width: 170
        },
        {
          headerName: 'Giá phòng',
          field: 'room_price',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.room_price, null),
          width: 100
        }
        // { headerName: '', field: '' },
      ],
      rows: [],
      selectedRows: [],
      totalBookings: 0,
      totalGuests: 0,

      // dialog
      dialogAddTransactionVisible: false,
      dialogChangeRoomVisible: false,
      dialogCancelBookingVisible: false,
      dialogViewCustomerProfileVisible: false,
      dialogBookingRoomDetailVisible: false,
      isEdit: false
    }
  },
  watch: {
    value(nv, ov) {
      this.dialogQuickViewBookingVisible = nv
      if (nv && this.booking != null) {
        this.fnGetBookingDetail()
      }
    },
    dialogQuickViewBookingVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    },
    // booking(nv, ov) {
    //   if (nv) {
    //     this.fnGetBookingDetail()
    //   }
    // },
    dialogViewCustomerProfileVisible(nv, ov) {
      if (!nv) {
        this.isEdit = false
      }
    }
  },
  mounted() {},
  methods: {
    onCloseBookingRoomDialog() {
      this.isBookingRoomDialogOpened = false
    },
    async onOpenUpdateBookingRoom() {
      const selectedRoom = this.selectedRows[0]
      if (selectedRoom?.sub_booking_group_id != null) {
        const bookingRoom = await getBookingRoom(
          selectedRoom?.sub_booking_group_id
        )
          .then(res => {
            return res.data
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: 'Đã có lỗi xảy ra'
            })
          })

        if (bookingRoom == null) {
          return
        }

        this.bookingRoomFormData = bookingRoom
        this.isBookingRoomDialogOpened = true
        this.bookingRoomFormAction = 'edit'
      }
    },
    async updateBookingRoom(id, payload) {
      await updateBookingRoom(id, payload)
        .then(res => {
          notifySuccess(res?.message)
          return true
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return false
        })
    },
    async onUpdateBookingRoom() {
      const payload = this.$refs.BookingRoomForm.dehydrateForm()

      if (this.bookingRoomFormData.id) {
        if (
          !(await this.updateBookingRoom(this.bookingRoomFormData.id, payload))
        ) {
          await this.fnGetBookingDetail()
          return
        }
      }

      Object.assign(
        this.formData.booking_room[this.bookingRoomTableIndex],
        payload
      )
      this.onCloseBookingRoomDialog()
      this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells(
        {
          force: true
        }
      )
    },
    onCheckin() {
      this.fnCheckin(this.selectedRows.map(item => item?.sub_booking_group_id))
    },
    onCheckinAll() {
      this.fnCheckin(this.rows.map(item => item?.sub_booking_group_id))
    },

    // handle call api
    fnCheckin(data) {
      checkin(data)
        .then(data => {
          if (!data.is_error) {
            this.$message({
              message: data.message,
              type: 'success'
            })

            // reload
            this.$emit('onReloadAfterCheckin')
            this.fnGetBookingDetail()
          } else {
            // throw new Error(data)
            this.$message({
              message: data?.message,
              type: 'error'
            })
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnGetBookingDetail() {
      this.searchParams = {
        ...this.searchParams,
        type: +this.booking.type,
        bookingId: this.booking.sub_booking_group_id || this.booking.booking_id
      }

      getBookingInfoDetail(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data
            this.totalBookings = res.total
            this.totalGuests = res.total_num_of_guests
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
